import React from 'react';
import { space, minWidth, fontSize, color } from 'styled-system';
import { Box } from 'grid-styled';
import { PulseLoader } from 'react-spinners';
import styled from 'styled-components';
import FontIcon from './FontIcon';

const StyledButton = styled.button`
    min-height: 30px;
    min-width: 180px;

    display: flex;
    align-items: center;

    border: 0;
    border-radius: 1px;
    cursor: pointer;

    text-transform: uppercase;
    font-weight: bold;
    background-color: #000;
    color: #fff;

    ${space};
    ${fontSize};
    ${minWidth};
    ${color};

    &:focus {
        outline: 2px solid #a6c7ff;
    }

    & ${FontIcon} {
        margin-right: 10px;
    }

    &:hover {
        opacity: 0.75;
    }

    &:active {
        opacity: 0.5;
    }

    &:disabled {
        opacity: 0.75;
        color: grey;
        cursor: default;
    }
`;

StyledButton.propTypes = {
    ...space.propTypes,
    ...fontSize.propTypes,
    ...minWidth.propTypes,
    ...color.propTypes
};

StyledButton.defaultProps = {
    alignItems: 'center',
    bg: 'gray.0',
    mr: 1,
    mb: 1
};

const Button = ({ icon, busy, children, ...props }) => (
    <StyledButton {...props}>
        {busy ? (
            <Box flex="1">
                <PulseLoader size={10} color="#fff" loading={true} />
            </Box>
        ) : (
            <React.Fragment>
                {icon && <FontIcon icon={icon} />}
                <Box flex="1">{children}</Box>
            </React.Fragment>
        )}
    </StyledButton>
);

export default Button;



// WEBPACK FOOTER //
// ./src/uic/Button.js